import React from "react";
//import { useGetSleepingPlan } from "@/api/api";
import Image from "next/image";

const SleepingPlan = ({ sleepingPlans }) => {
  //const { data: sleepingPlans } = useGetSleepingPlan(villaId);
  return (
    <div className="flex flex-col gap-2 mb-3 md:gap-0 lg:mb-12 md:mb-6">
      <span className="text-xl font-medium leading-normal text-themeBlack">
        Uyku Planı
      </span>
      <div className="grid grid-cols-2 sm:grid-cols-3 items-center sm:gap-4 gap-1.5 mt-5">
        {sleepingPlans?.map((plan, index) => (
          <div
            key={index}
            className="md:py-4 py-2.5 md:px-5 px-2.5 md:gap-4 gap-2 border border-[#E7EDF4] rounded-lg h-full"
          >
            <span className="text-sm font-bold leading-normal text-themeBlack">
              {plan?.room_name}
            </span>
            <div className="flex flex-col gap-1 mt-2 sm:gap-2">
              {plan?.items.map((item, index) => (
                <div key={index} className="flex items-center gap-x-2">
                  <Image
                    src="/icons/check.svg"
                    width={14}
                    height={14}
                    alt="tick"
                    className="object-contain"
                  />
                  <span className="text-xs font-normal leading-normal text-themeGray">
                    {item.item_name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SleepingPlan;
